import Helper from '../../Helper.js';

if($('#vetting-questions').length){
    var app = new Vue({
        el: '#vetting-questions',
        data: {
            questions:{},
            answers:{},
            questionAnswers:[],
            applicationType:applicationType,
            applicationId:applicationId,
            networkSlug: networkSlug,
            networkGroupSlug: networkGroupSlug,
        },
        methods: {
            getAnswers(){
                axios.get('/api/v1/network/'+this.networkSlug+'/applications/'+this.applicationType+'/'+this.applicationId+'/answers').then((response) =>  {
                    this.answers = response.data;
                    this.assignAnswers();
                }).catch(function (error) {
                    console.log(error);
                });
            },
            getQuestions(){
                axios.get('/api/v1/network/'+this.networkSlug+'/applications/'+this.applicationType+'/questions').then((response) =>  {
                    this.questions = response.data;
                    if(this.applicationId){
                        this.getAnswers();
                        // this.assignAnswers();
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            displayQuestion(question){
                if(question.dependancy_question_id && question.dependancy_question_answers){
                    var dependancyAnswers = question.dependancy_question_answers.split(",");
                    var dependancyQuestionAnswers = this.questionAnswers[question.dependancy_question_id];
                    if(Array.isArray(dependancyQuestionAnswers)){
                        if(dependancyQuestionAnswers){
                            var array = [];
                            dependancyQuestionAnswers.forEach((value, key) => {
                                if(value){
                                    array.push(key);
                                }
                            });
                            var success = false;
                            array.forEach((val) => {
                                if(dependancyAnswers.includes(''+val+'')){
                                    success = true;
                                }
                            });
                            if(success){
                                // Helper.jqueryHelpers();
                                return true;
                            }
                        }
                    }else{
                        if(dependancyQuestionAnswers && dependancyAnswers.includes(''+dependancyQuestionAnswers+'')){
                            // Helper.jqueryHelpers();
                            return true;
                        }
                    }
                    return false;
                }else{
                    return true;
                }
            },
            assignAnswers(){
                this.questions.forEach((question) => {
                    if(question.id){
                        if(this.answers.length){
                            var result = this.answers.filter(answer => {
                                return answer.question_id === question.id
                            });
                            if(result.length){
                                if(question.question_type_id == 4){
                                    this.questionAnswers[question.id] = result[0].answer;
                                }else if(question.question_type_id == 2){
                                    this.questionAnswers[question.id] = [];
                                    result.forEach((resultItem) => {
                                        this.questionAnswers[question.id][resultItem.answer_option_id] = true;
                                    });
                                }else{
                                    this.questionAnswers[question.id] = result[0].answer_option_id;
                                }
                            }else{
                                if(question.question_type_id == 1){
                                    this.questionAnswers[question.id] = "";
                                }else{
                                    this.questionAnswers[question.id] = [];
                                }
                            }
                        }else{
                            if(question.question_type_id == 1){
                                this.questionAnswers[question.id] = "";
                            }else{
                                this.questionAnswers[question.id] = [];
                            }
                        }
                    }
                });
                this.$forceUpdate();
            }
        },
        mounted () {
            this.$nextTick(() => {
                // Helper.jqueryHelpers();
                this.getQuestions(this.networkSlug, this.applicationType);
            });
        }
    });
}